if (!customElements.get('writting-component')) {
	class WrittingComponent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				imageWrapper: '.writting-preview__image',
				imageWrapperSpan: '.writting-preview__image span',
				mainInput: '#writting',
				checkBoxFeedBack: '.morse-writting__checkbox',
				previewWrapper: '.product-info__morse-writting-preview',
				errorMessage: '.writting-preview__error',
				extraPriceWrapper: '.product-info__extra-product',
				productForm: '.product-form',
				labels: '.writting-preview__labels',
			};

			this.elements = {
				imageWrapper: this.querySelector(this.selectors.imageWrapper),
				imageWrapperSpan: this.querySelector(this.selectors.imageWrapperSpan),
				mainInput: this.querySelector(this.selectors.mainInput),
				checkBoxFeedBack: this.querySelector(this.selectors.checkBoxFeedBack),
				previewWrapper: this.querySelector(this.selectors.previewWrapper),
				errorMessage: this.querySelector(this.selectors.errorMessage),
				extraPriceWrapper: this.querySelector(this.selectors.extraPriceWrapper),
				labels: this.querySelector(this.selectors.labels),
			};

			this.additionalProductHandle = this.dataset.extraProduct;
			this.additionalPricePerLetter = parseInt(this.dataset.priceItem);
			this.additionalProductText = this.dataset.extraProductText;
			this.productForm = this.closest('.product-form')
				? this.closest('.product-form').querySelector('buy-buttons form')
					? this.closest('.product-form').querySelector('buy-buttons form')
					: false
				: false;
			this.additionalProductData = {};
			this.selectedVariant = null;
			this.divideBySides = this.elements.labels ? true : false;

			if (this.productForm) {
				this.getAdditionalProductData();
				this.debounceHandler = this.debounce(() => this.populatePreview(), 500);
				this.elements.mainInput.addEventListener('input', () => this.debounceHandler());
			} else {
				this.classList.add('hidden');
			}
		}

		getAdditionalProductData() {
			fetch(`/products/${this.additionalProductHandle}.js`)
				.then((response) => response.json())
				.then((data) => {
					this.additionalProductData = data;
					this.selectedVariant = this.additionalProductData.variants[0];
				});
		}

		populatePreview() {
			if (this.elements.mainInput.value === '' || this.elements.mainInput.value.trim() === '') {
				this.elements.previewWrapper.classList.remove('open');
				this.handleExtraProperties(false);
				this.elements.mainInput.value = '';
				this.elements.extraPriceWrapper.innerHTML = '';
				return;
			} else {
				this.elements.previewWrapper.classList.add('open');
			}
			let value = this.elements.mainInput.value;

			const regex = /[^a-zA-Z]+/g;
			let newValue = value.replace(/ /g, '').replace(regex, '');

			if (newValue != value) {
				this.elements.errorMessage.classList.remove('hidden');
			} else {
				this.elements.errorMessage.classList.add('hidden');
			}

			this.elements.imageWrapper.querySelectorAll('.image__letter').forEach((letter, index, existingLetters) => {
				letter.classList.add('hidden');
				letter.style.order = 0;

				for (let i = index + 1; i < existingLetters.length; i++) {
					if (letter.innerHTML === existingLetters[i].innerHTML) {
						existingLetters[i].remove();
					}
				}
			});

			const seenLetters = new Set();

			[...newValue].forEach((char, index, entireArray) => {
				const charToLowercase = char.toLowerCase();
				let elementToShow = this.elements.imageWrapper.querySelector(`[data-letter="${charToLowercase}"]`);
				elementToShow.classList.remove('image__letter--margin-left');

				if (seenLetters.has(charToLowercase)) {
					// If the letter has appeared, clone the elementToShow
					const clonedElement = elementToShow.cloneNode(true);

					// Add the cloned element to its parent
					elementToShow.parentNode.appendChild(clonedElement);
					clonedElement.classList.remove('hidden');
					clonedElement.classList.remove('image__letter--margin-left');
					clonedElement.style.order = index;
				} else {
					seenLetters.add(char);
					elementToShow.classList.remove('hidden');
					elementToShow.style.order = index;
				}

				if (this.divideBySides) {
					this.divideLettersBySides();
				}
			});

			this.calculateAdditionalProduct();
			this.handleExtraProperties(true, newValue);
		}

		calculateAdditionalProduct(value) {
			const visibleLetters = this.elements.imageWrapper.querySelectorAll('.image__letter:not(.hidden)');
			const numberOfLetters = Array.from(visibleLetters)
				.map((letter) => {
					const number = letter.dataset.numberStones;
					return number ? +number : 0;
				})
				.reduce((a, b) => a + b, 0);
			const additionalPrice = numberOfLetters * this.additionalPricePerLetter;

			this.selectedVariant = this.additionalProductData.variants.find((variant) => variant.price / 100 == additionalPrice);

			if (!this.selectedVariant) {
				this.selectedVariant = this.additionalProductData.variants[0];
			}

			this.elements.extraPriceWrapper.innerHTML = `${this.additionalProductText} <br><strong>${(this.selectedVariant.price / 100).toFixed(2)} ${
				window.Shopify.currency.active
			}</strong>`;
		}

		divideLettersBySides() {
			const visibleLetters = this.elements.imageWrapper.querySelectorAll('.image__letter:not(.hidden)');
			const elementsArrangedByOrder = Array.from(visibleLetters).sort((a, b) => a.style.order - b.style.order);

			elementsArrangedByOrder.forEach((element, index, entireArray) => {
				switch (index) {
					case 0:
						element.classList.remove('image__letter--margin-left');
						this.elements.labels.classList.add('hidden');
						break;
					case 1:
						if (entireArray.length > 2) {
							element.classList.remove('image__letter--margin-left');
							this.elements.labels.classList.add('hidden');
						} else {
							element.classList.add('image__letter--margin-left');
							this.elements.labels.classList.remove('hidden');
						}
						break;
					case 2:
						if (entireArray.length > 3) {
							element.classList.add('image__letter--margin-left');
							this.elements.labels.classList.remove('hidden');
						} else {
							element.classList.remove('image__letter--margin-left');
							this.elements.labels.classList.add('hidden');
						}
						break;
					case 3:
						element.classList.remove('image__letter--margin-left');
						this.elements.labels.classList.remove('hidden');
						break;
				}
			});
		}

		handleExtraProperties(value, newValue = null) {
			this.productForm.querySelector("input[name='properties[Morse Letters]']")
				? this.productForm.querySelector("input[name='properties[Morse Letters]']").remove()
				: '';

			if (value) {
				const newInput = document.createElement('input');
				newInput.type = 'hidden';
				newInput.name = 'properties[Morse Letters]';
				newInput.value = newValue;
				this.productForm.appendChild(newInput);
				this.elements.checkBoxFeedBack.classList.remove('hidden');
				this.productForm.setAttribute('data-additional-product', this.selectedVariant.id);
				this.productForm.setAttribute('data-additional-product-property', newValue);
			} else {
				this.productForm.removeAttribute('data-additional-product', '');
				this.productForm.removeAttribute('data-additional-product-property', '');
				this.elements.checkBoxFeedBack.classList.add('hidden');
			}
		}

		debounce(callback, wait) {
			let timeout;
			return (...args) => {
				clearTimeout(timeout);
				timeout = setTimeout(function () {
					callback.apply(this, args);
				}, wait);
			};
		}
	}

	customElements.define('writting-component', WrittingComponent);
}
